import React from 'react';
import { FC } from 'react';
import styled from 'styled-components';

const FormControlLabel = styled.div`
  padding: 10px 0px;
  display: flex;
  font-size: 14px;
  justify-content: space-between;
`;

const FormControlContainer = styled.div<{ rightComponent?: any; placeholder?: any }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  // width: 80%;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const FormControl: FC<{
  label: string;
  detail?: string;
  rightComponent?: any;
  children?: React.ReactNode;
  placeholder?: string;
}> = ({ placeholder, label, rightComponent, detail, children }) => {
  return (
    <FormControlContainer placeholder={placeholder}>
      <FormControlLabel>
        <span className="label-css">
          <span className="label-style">{label}</span> {detail}{' '}
        </span>
      </FormControlLabel>
      {children}
    </FormControlContainer>
  );
};
